export const FilterTrueFalse = (props) => {

    return <div className={`date-filter col-sm-${props.filter.gridWidth != 0 ? props.filter.gridWidth : 4}`}>
        <input id={`cb_${props.filter.contentUId}`} type={"checkbox"} defaultChecked={props.filter.trueFalseValue} onChange={(evt) => {
            props.filter.trueFalseValue = evt.target.checked;
            let newState = { ...props.ficheData };
            props.setFicheData(prev => {
                return {
                    ...prev,
                    filter: newState.filter
                }
            });
        }} />
        <label for={`cb_${props.filter.contentUId}`}>{props.filter.text}</label>
    </div>
}